import './ticket.scss';
import Moment from 'react-moment';
import { useParams, useHistory } from 'react-router-dom';
import { RootState, TicketType } from 'types';
import api from 'api';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from 'redux/reducers';

function Ticket({
    item,
}: {
    item: TicketType,
}) {
    const params: any = useParams();
    const history = useHistory();
    const dispatch = useDispatch();
    const { board } = useSelector((state: RootState) => state);
    const user = useSelector((state: RootState) => state.user);

    const openTicket = () => {
        if (params.ticketId) {
            history.replace(`/client/${params.clientId}/board/${params.boardId}/ticket/${item.TicketDetails.Id}`);
        } else {
            history.push(`/client/${params.clientId}/board/${params.boardId}/ticket/${item.TicketDetails.Id}`);
        }
    }

    return (
        <div id={`ticket${item.TicketDetails.Id}`} className="ticket-wrapper" onClick={openTicket}>
            <div className="ticket-content">
                <div className="ticket" style={
                    item.Labels?.length ? {
                        borderLeft: '5px solid',
                        borderImage: `linear-gradient(to bottom, ${item.Labels?.map((x: any, i: number) => {
                            return `#${x.Colour} ${i * (100 / item.Labels!.length)}%, #${x.Colour} ${(i + 1) * (100 / item.Labels!.length)}%`
                        })}) 1`,
                    } : {}
                }>
                    <div className="ticket-header">
                        <p dangerouslySetInnerHTML={{ __html: item.TicketDetails.Heading }}></p>
                        {/* <i className="far fa-angle-right" onClick={e => {
                            e.preventDefault();
                            moveTicketNext();
                        }}></i> */}
                        {item.TicketDetails.IsCompleted && <i className="far fa-check"></i>}
                    </div>
                    {/* {item?.Members?.map((e: any) => {
                        return (
                            <span className="ticket-member" title={`${e.Name} ${e.Surname}`} key={e.Id} >{e.Name[0]}{e.Surname[0]}</span>
                        )
                    })} */}
                    { item.Assignee && <span className="ticket-member assignee" title={`${item.Assignee.Name} ${item.Assignee.Surname}`} >{`${item.Assignee.Name} ${item.Assignee.Surname[0]}`}</span> }
                    { !item.Assignee && <span className="ticket-member no-assignee">No assignee</span> }
                    <div className="ticket-body">
                        <span className="members" title="Members"><i className="fa fa-users"></i>{item.MemberCount}</span>
                        <span className="labels" title="Labels"><i className="fa fa-tags"></i>{item.LabelCount}</span>
                        <span className="date"><Moment format="YYYY/MM/DD HH:mm">{item.TicketDetails.DateCreated}</Moment></span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Ticket;